import { render, staticRenderFns } from "./ChamberColumnList.vue?vue&type=template&id=70e60990"
import script from "./ChamberColumnList.vue?vue&type=script&lang=js"
export * from "./ChamberColumnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports